"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PillToggle } from "@/components/ui/controls/PillToggle";
import { useLabels } from "@/lib/labels/LabelsProvider";
import type { LivescoreFilter } from "@/views/livescore/utils/livescore";
interface LivescoreFiltersProps {
  filter: LivescoreFilter;
  onChange: (filter: LivescoreFilter) => void;
  allowedFilters: LivescoreFilter[];
}
export function LivescoreFilters(t0) {
  const $ = _c(12);
  const {
    filter,
    onChange,
    allowedFilters
  } = t0;
  const labels = useLabels();
  const ls = labels.livescore;
  let t1;
  if ($[0] !== allowedFilters || $[1] !== ls.filters.all || $[2] !== ls.filters.finished || $[3] !== ls.filters.live || $[4] !== ls.filters.myLeagues || $[5] !== ls.filters.popular || $[6] !== ls.filters.upcoming) {
    const allOptions = [{
      id: "all" as LivescoreFilter,
      label: ls.filters.all
    }, {
      id: "popular" as LivescoreFilter,
      label: ls.filters.popular
    }, {
      id: "my-leagues" as LivescoreFilter,
      label: ls.filters.myLeagues
    }, {
      id: "upcoming" as LivescoreFilter,
      label: ls.filters.upcoming
    }, {
      id: "live" as LivescoreFilter,
      label: ls.filters.live
    }, {
      id: "finished" as LivescoreFilter,
      label: ls.filters.finished
    }];
    t1 = allOptions.filter(opt => allowedFilters.includes(opt.id));
    $[0] = allowedFilters;
    $[1] = ls.filters.all;
    $[2] = ls.filters.finished;
    $[3] = ls.filters.live;
    $[4] = ls.filters.myLeagues;
    $[5] = ls.filters.popular;
    $[6] = ls.filters.upcoming;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const options = t1;
  let t2;
  if ($[8] !== filter || $[9] !== onChange || $[10] !== options) {
    t2 = <PillToggle options={options} activeId={filter} onChange={onChange} size="sm" />;
    $[8] = filter;
    $[9] = onChange;
    $[10] = options;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}